import * as Sentry from '@sentry/browser';

import { store } from '#store/store.ts';

import { config } from '../../config.ts';
import { getUserProfile } from '../login/loginSlice.ts';

/**
 * EventProcessors can be used to drop events, add/remove/modify them or remove sensitive data
 * Only call it once
 */
export const initSentryEventProcessor = () =>
    Sentry.addEventProcessor((event, _hint) => {
        // returning `null` will drop the event
        const state = store.getState();
        const userProfile = getUserProfile(state);
        const accountId = userProfile?.account;
        const accountSub = userProfile?.sub;

        event.extra = { ...event.extra };
        event.tags = { ...event.tags };
        event.user = {
            ...event.user,
            id: accountSub ?? accountId,
            accountSub,
            accountId,
        };
        return event;
    });

if (import.meta.env.PROD) {
    const release = import.meta.env.VITE_COMMIT_HASH ?? import.meta.env.VITE_SENTRY_RELEASE ?? config.serviceVersion;
    const environment = config.serviceEnvironment;
    const dsn = config.sentryToken;

    Sentry.init({ dsn, environment, release });
    initSentryEventProcessor();
}

export const reportErrorToSentry: typeof Sentry.captureException = import.meta.env.PROD
    ? Sentry.captureException
    : () => '';
